/* eslint-disable */
import { useCallback, useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './SideNav.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { ReactComponent as ExploreSVG } from '../../icons/explore.svg';
import { ReactComponent as CollectionsSVG } from '../../icons/collection.svg';
import { ReactComponent as QuestionMarkSVG } from '../../icons/questionMark.svg';
import CollectionTab from '../CollectionTab/CollectionTab';
import { GLOBAL_PORTAL_IDENTIFIER } from '../../portals';
import { useUserCollections } from '../../hooks/collections';
import useCurrentUser from '../../auth/useCurrentUser';
import useScoutAuth from '../../auth/useScoutAuth';
import FakeAuthModal from '../../auth/FakeAuthModal';

export default function SideNav() {
  const [showCollectionTab, setShowCollectionTab] = useState(false);
  const [{ activePortalAbbreviation, globalPortalsAreActive }] =
    useUserCollections();
  const { login, logout, isFakeAuthModalOpen, onFakeAuthModalDismiss } =
    useScoutAuth();
  const { isAuthenticated, user } = useCurrentUser();
  const onCollectionTabDismiss = useCallback(() => {
    setShowCollectionTab(false);
  }, []);

  return (
    <nav className="side-nav">
      <Link alt="Scout" className="title" to="/">
        <h2 className="scout-h2">scout</h2>
        <p className="scout-sub">open data discovery</p>
      </Link>
      <NavLink
        className={({ isActive }) =>
          classNames('explore', {
            'active-nav': isActive,
          })
        }
        alt="Explore"
        exact
        to={`/explore/${
          globalPortalsAreActive
            ? GLOBAL_PORTAL_IDENTIFIER
            : activePortalAbbreviation
        }`}
      >
        <ExploreSVG />
        <h1>Explore</h1>
      </NavLink>
      <div className="collections-button" style={{ position: 'relative' }}>
        <button
          onClick={e => {
            e.stopPropagation();
            setShowCollectionTab(prev => !prev);
          }}
          type="button"
          className="header-button"
        >
          <CollectionsSVG />
          <h1>Collections</h1>
        </button>
        {showCollectionTab ? (
          <CollectionTab
            visible={showCollectionTab}
            onDismiss={onCollectionTabDismiss}
          />
        ) : null}
      </div>
      <NavLink
        exact
        className={({ isActive }) =>
          classNames('about', {
            'active-nav': isActive,
          })
        }
        alt="about"
        to="/about"
      >
        <QuestionMarkSVG />
        <h1>About</h1>
      </NavLink>
      <a
        href="https://airtable.com/app9QpoVEHQcmXJtM/pag8maXVZUx28riRu/form"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon size="2x" icon={faCommentDots} />
        <h1>Feedback</h1>
      </a>
      <div
        role="button"
        className="login"
        onClick={async () => {
          if (isAuthenticated) {
            await logout();
          } else {
            await login();
          }
        }}
      >
        <FontAwesomeIcon size="2x" icon={faUser} />
        {/* <h1>{user ? user.username : 'account'}</h1> */}
        <h1>{isAuthenticated ? 'Sign out' : 'Sign in'}</h1>
      </div>
      <FakeAuthModal
        isOpen={isFakeAuthModalOpen}
        onDismiss={onFakeAuthModalDismiss}
      />
    </nav>
  );
}
